module.exports = __webpack_public_path__ + "static/pumpjack2-bb590f7bdb3e1c8d07a60d74737c33eb.jpg";